import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { SectionHeading } from "@/components/Primitives";
import api from "@/lib/api";

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    body: [
      "We collect only the information you provide through our enquiry, estimate and referral forms — such as your name, business name, phone, optional email and the features you're interested in.",
      "We use this information solely to respond to your enquiry, prepare proposals, and manage projects or referral commissions.",
      "We do not sell your personal data. Referral partners can see only their own referrals and earnings; clients can see only their own projects.",
      "You can request access to or deletion of your data by contacting us through the details on our Contact page.",
    ],
  },
  terms: {
    title: "Service Terms",
    body: [
      "Quotes and estimates are indicative until confirmed in a written proposal. Final pricing depends on confirmed requirements.",
      "Domain, hosting and third-party services are billed at actual cost and renew annually at provider rates. We do not offer lifetime free hosting or unlimited support.",
      "Revisions are limited to the allowance in your chosen package. Additional revisions may be chargeable.",
      "Project files and content are handed over after final payment. Timelines depend on timely content and feedback from you.",
    ],
  },
  "referral-terms": {
    title: "Referral Terms",
    body: [
      "Commission is earned per eligible converted project only — not for merely submitting a contact.",
      "A referral qualifies when the referred project is marked Won, the required full client payment is recorded and verified, any configured holding period has ended, and an admin approves the commission.",
      "The applicable commission rate is snapshotted when your referral is accepted. Later rate changes do not alter existing entitlements.",
      "Attribution uses the first valid referral code captured within the configured attribution window (initially 30 days) and is locked when the lead is created. Self-referrals and abuse are not eligible.",
      "Minimum payout threshold applies. Pressing 'Mark Paid' records an external payment made through your chosen method; it does not transfer money automatically. We never ask for UPI PINs, bank passwords or OTPs.",
      "Refunds or cancellations may lead to recorded commission adjustments or reversals, preserving an auditable history.",
    ],
  },
};

export default function Legal() {
  const { doc } = useParams();
  const c = CONTENT[doc] || CONTENT.privacy;
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
      <SectionHeading title={c.title} subtitle="This content is pending business review before launch." />
      <div className="glass-strong rounded-3xl p-8 space-y-4">
        {c.body.map((p, i) => (<p key={i} className="text-slate-300 leading-relaxed">{p}</p>))}
      </div>
    </div>
  );
}
